export function headerFunc() {
  var resizecheck;
  // ハンバーガーメニュー実装
  $('.navToggle').on('click', function () {
    resizecheck = $('#responsibleCheck').width();
    $('.navToggle').toggleClass('closeNav');
    if ($(this).hasClass('closeNav')) {
      $('.headerNavWrap').fadeIn(800);
    } else {
      $('.headerNavWrap').fadeOut(800);
    }
  });

  $('.jsPages').hover(
    function () {
      resizecheck = $('#responsibleCheck').width();
      if (resizecheck == '1') {
        $(this).addClass('open');
        $(this).find('.eachServicePages').stop().fadeIn();
      }
    },
    function () {
      resizecheck = $('#responsibleCheck').width();
      if (resizecheck == '1') {
        $(this).removeClass('open');
        $(this).find('.eachServicePages').stop().fadeOut();
      }
    }
  );
  $('.jsSub').hover(
    function () {
      console.log("test");
      resizecheck = $('#responsibleCheck').width();
      if (resizecheck == '1') {
        $(this).find('ol').stop().fadeIn();
      }
    },
    function () {
      resizecheck = $('#responsibleCheck').width();
      if (resizecheck == '1') {
        $(this).find('ol').stop().fadeOut();
      }
    }
  );
}